<template>
  <section class="menu-height bg-gray-200 d-flex w-100">
    <div
      class="d-flex flex-column my-auto justify-content-around w-100"
      style="max-height: calc(90vh - 150px); min-height: calc(90vh - 150px)"
    >
      <div
        v-for="item in list"
        :key="item.title"
        class="d-flex flex-row cursor-pointer fw-bold w-100"
        @click="switchView(item.href)"
      >
        <v-icon
          :icon="item.icon"
          height="20"
          width="20"
          class="ms-4 my-auto"
        />
        <div class="mx-auto">
          <span class="me-5">
            {{ item.title }}
          </span>
        </div>
      </div>
      <div class="w-100">
        <a
          :href="getAppUrl('')"
          class="btn btn-primary d-flex flex-row justify-content-center mx-4 "
        >
          <div> Ajouter contrat </div>
          <v-icon
            icon="plus-white"
            height="20"
            width="20"
            class="ms-2"
          />
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          title: 'Parrainage',
          icon: 'gift',
          color: 'yellow-400',
          href: 'perks/sponsorship',
        },
        {
          title: 'Bons plans',
          icon: 'star',
          color: 'yellow-400',
          href: 'perks/deals',
        },
        {
          title: 'Documents',
          icon: 'folder',
          color: 'yellow-500',
          href: 'documents',
        },
        {
          title: 'Devis',
          icon: 'traffic-cone',
          href: 'quotes',
        },
        {
          title: 'Sinistres',
          icon: 'cloud',
          href: 'claim',
        },
      ],
    };
  },
  methods: {
    getAppUrl(url) {
      return `${import.meta.env.VITE_WIDGET_URL}${url}`;

    },
    switchView(href) {
      const path = `/client/${href}`;
      if (this.$route.path !== path) {
        this.$router.push(path, this.callback);
      }
    },
  },
};
</script>
<style scoped>
.menu-height {
  position: absolute;
  top: 0;
  right: 0;
  left:0;
  z-index: 29;
  bottom: 0;
}
</style>
